import * as React from 'react';

import redirect from 'js/lib/coursera.redirect';
import Retracked from 'js/lib/retracked';
import type { EventData, WithTrackingData } from 'js/lib/retracked';

import type { ProgramSuggestion } from 'bundles/clips/components/short-form-content/SFCVLPSharedTypes';

import _t from 'i18n!nls/clips';

type SuggestedProgramRedirectProps = {
  suggestedToJoinProgram: ProgramSuggestion;
  _eventData: EventData;
  _withTrackingData: WithTrackingData;
  courseSlug: string;
  programSlug?: string;
  orgSlug?: string;
  itemId: string;
  routerLocation: {
    pathname: string;
    search: string;
  };
};

class SuggestedProgramRedirect extends React.Component<SuggestedProgramRedirectProps> {
  componentDidMount() {
    const {
      suggestedToJoinProgram,
      _eventData,
      _withTrackingData,
      courseSlug,
      programSlug,
      orgSlug,
      itemId,
      routerLocation: { pathname, search },
    } = this.props;
    const currentPathEncoded = encodeURIComponent(pathname + search);

    Retracked.trackComponent(
      _eventData,
      { courseSlug, programSlug, orgSlug, itemId },
      'short_form_content_redirect_suggested_join_program',
      'view',
      _withTrackingData
    );

    // TODO: Change to react router method once Clips is migrated to program-home
    redirect.setLocation(`/programs/${suggestedToJoinProgram.slug}?redirectPath=${currentPathEncoded}`);
  }

  render() {
    return (
      <div>
        <p>{_t('Redirecting...')}</p>
      </div>
    );
  }
}

export default SuggestedProgramRedirect;
